import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';
import { gameLiveConnection } from '../../services';
import { GAMBLE_TYPES } from '../../enums/constants';
import { doBetStore } from '../../store/doBetStore';

export const GambleSection = observer(({ isDisable }) => {
  const { gambleType, setGambleType } = doBetStore;
  const { betId, setIsAllowSendToInvoke, isAllowSendToInvoke } = gameStore;
  const { isDemo } = applicationStore;

  const handleDoGamble = useCallback(
    (type) => {
      if (!isDisable && isAllowSendToInvoke) {
        setTimeout(() => {
          setGambleType(type);
        }, 300);
        setIsAllowSendToInvoke(false);
        if (isDemo) {
          gameLiveConnection.doDemoGamble(type);
        } else {
          gameLiveConnection.doGamble({ type, betId });
        }
      }
    },
    [isDisable, isAllowSendToInvoke, setGambleType, setIsAllowSendToInvoke, isDemo, betId]
  );

  return (
    <div className='tb-bonus-circle-wrp'>
      {GAMBLE_TYPES.map((item, index) => {
        if (Number.isInteger(gambleType)) {
          if (gambleType === index) {
            return (
              <div
                key={item}
                className={`tb-bonus-circle-item ${
                  isDisable || !isAllowSendToInvoke ? 'disabled' : 'pulse-anim'
                }`}
                onClick={() => handleDoGamble(index)}
              >
                <div className='tb-bonus-circle-inner'>
                  <p className='tb-bonus-circle-number'>{item}</p>
                </div>
              </div>
            );
          }
          return null;
        }
        return (
          <div
            key={item}
            className='tb-bonus-circle-item pulse-anim'
            onClick={() => handleDoGamble(index)}
          >
            <div className='tb-bonus-circle-inner'>
              <p className='tb-bonus-circle-number'>{item}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
});
